export default function ReportsRepository($http, appSettings) {
  'ngInject';
  return {
    getAllReports: function () {
      const uri = `${appSettings.InReachApiReportEndpoint}?include=groups`;
      return $http.get(uri);
    },
    getReport: function (id) {
      const uri = `${appSettings.InReachApiReportEndpoint}/${id}`;
      return $http.get(uri);
    },
    excuteReport: function (reportName) {
      const uri = `${appSettings.VikingEndpoint}/default.aspx?path=${reportName}`;
      return $http.get(uri);
    }
  };
}